import * as Ariakit from '@ariakit/react'
import * as React from 'react'

import { useLmfAnalyticsOnClick } from '@syconium/little-miss-figgy'

import { PlacementId } from '../../../../../containers/EmbroideryContainer/combination-rules/placementIds'

import { placementName, priceSuffix, statusSuffix } from './placementLabels'
import {
  PlacementCardHeaderButton,
  PlacementCardShell,
  PlacementLabel,
  PlacementStatus,
} from './styles'

export type PlacementOptionProps = {
  placementId: PlacementId
  priceLabel?: string
  statusLabel?: string
  isSelected: boolean
  disabled?: boolean
  invalid?: boolean
  onSelect(placementId: PlacementId): void
}

/**
 * One placement in a single-select picker
 */
export const PlacementOption: React.FC<PlacementOptionProps> = ({
  placementId,
  priceLabel,
  statusLabel,
  isSelected,
  disabled = false,
  invalid = false,
  onSelect,
}) => {
  const name = placementName(placementId)
  const select = useLmfAnalyticsOnClick({
    onClick: () => onSelect(placementId),
    label: placementId,
    variations: ['placement'],
    element: 'button',
    href: undefined,
  })

  return (
    <PlacementCardShell $selected={isSelected && !disabled} $disabled={disabled} $invalid={invalid}>
      <Ariakit.Radio
        accessibleWhenDisabled
        disabled={disabled}
        value={placementId}
        onChange={select}
        render={
          <PlacementCardHeaderButton type='button'>
            <span>
              <PlacementLabel $disabled={disabled}>
                {name}
                {priceSuffix(priceLabel)}
              </PlacementLabel>
              {statusLabel !== undefined && (
                <PlacementStatus $disabled={disabled}>{statusSuffix(statusLabel)}</PlacementStatus>
              )}
            </span>
          </PlacementCardHeaderButton>
        }
      />
    </PlacementCardShell>
  )
}
